var _Circle, _Path, _Path2, _Path3, _Path4, _Path5, _Path6, _Path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgEth = function SvgEth(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 10,
    cy: 10,
    r: 9.333,
    fill: "white",
    stroke: "#B3B3B3",
    strokeWidth: 1.333
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.667a8.667 8.667 0 1 0 0-17.334 8.667 8.667 0 0 0 0 17.334ZM10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z",
    fill: "#B3B3B3"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "m10.012 4-.08.274v7.935l.08.08 3.684-2.177L10.012 4Z",
    fill: "#2F3030"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "m10.018 4-3.684 6.112 3.684 2.178V4Z",
    fill: "#828384"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    d: "m10.012 12.986-.045.056v2.826l.045.133 3.686-5.19-3.686 2.175Z",
    fill: "#2F3030"
  })), _Path5 || (_Path5 = /*#__PURE__*/React.createElement(Path, {
    d: "M10.018 16v-3.014L6.333 10.81 10.018 16Z",
    fill: "#828384"
  })), _Path6 || (_Path6 = /*#__PURE__*/React.createElement(Path, {
    d: "m10.014 12.29 3.683-2.177-3.683-1.674v3.852Z",
    fill: "#131313"
  })), _Path7 || (_Path7 = /*#__PURE__*/React.createElement(Path, {
    d: "m6.334 10.113 3.684 2.178V8.439l-3.684 1.674Z",
    fill: "#343535"
  })));
};
export default SvgEth;